namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class OAuthProfileDialog extends GContentBase {
        private formEl: JQuery<HTMLElement>; 
        private type: TypeDialogs;
        private ixs_oap: string;
        private isDebug: boolean;
        private serviceCnt: GContent;

        onContentReady() {
            this.createActions();
            this.createCommandBar();
            this.createForm();
        }

        private srv(): GContent {
            if (!this.serviceCnt)
                this.serviceCnt = this.createServiceContent("Gordic.Adm.WebControls.OAuthProfileDialog")
            return this.serviceCnt;
        }

        private createActions() {
            this.actions.addRange({
                actOAuthProfilSelectConsentOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.oAuthProfilConsentOK(ev, ctx);
                    }
                },
                actOAuthProfilSelectLoginOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.oAuthProfilLoginOK(ev, ctx);
                    }
                },
                actOAuthProfilSelectCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.oAuthProfilCancel(ev, ctx);
                    }
                },
            })
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar([
                {
                    action: (this.type == TypeDialogs.consent) ? this.actions.actOAuthProfilSelectConsentOk : this.actions.actOAuthProfilSelectLoginOk,
                    primary: true
                },
                {
                    action: this.actions.actOAuthProfilSelectCancel,
                }
            ]))
        }

        private createForm() {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                name: "selectOAuthProfilForm",
                customClass: "selectOAuthProfilForm"
            }).addRow("jres:33000388").addField("gselectbox", Gordic.Prefabs.Select.ginsoap(), { //RC 33000388 : OAuth profil
                name: "profil",
                model: "model.ixs_oap=value.ixs_oap;model.ixs_oap_txt<=value.nazev",
                dropdown: true,
                initialValue: (this.ixs_oap) ? { ixs_oap: this.ixs_oap } : null,
                disabled: this.ixs_oap != null && this.ixs_oap != undefined,
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                serverFilters: {
                    typ_aut_oauth: (this.ixs_oap) ? null : ((this.type == TypeDialogs.consent) ? 10 : null)
                }
            }).addRow("jres:33000394").addField("gselectbox", Gordic.Prefabs.Select.gincose(), { //RC 33000394 : Slu�ba
                name: "sluzba",
                model: "model.oauth_service=value.oauth_service;model.oauth_service_txt<=value.oauth_service_txt",
                dropdown: true,
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            })
            this.formEl = $("<div>").gform("createFrom", form).appendTo(this.element);
        }

        private oAuthProfilConsentOK(ev, ctx) {
            var cnt = $.content($(ev.target));
            var form = cnt.findForms("selectOAuthProfilForm");
            if (form.gform("isValid")) {
                var data: any = {};
                form.findFields().gfield("model", "collect", data)
                this.ziskatOAuthConsent(data);
            }
        }

        private oAuthProfilLoginOK(ev, ctx) {
            var cnt = $.content($(ev.target));
            var form = cnt.findForms("selectOAuthProfilForm");
            if (form.gform("isValid")) {
                var data: any = {};
                form.findFields().gfield("model", "collect", data)
                this.testLoginOAuth(data);
            }
        }

        private ziskatOAuthConsent(data) {
            this.srv().call("ZiskatOAuthConsent", { ixs_oap: data.ixs_oap, sluzba: data.oauth_service }).done((output: Gordic.Gin.Interface.GAdmOAuthDto) => {
                //if (this.isDebug == true)
                //    console.log(output.State)
                //$(".test-o-auth").text(output.state ? output.state : "");
            }).done((obj) => {
                if (obj.Url) {
                    if (this.isDebug == true)
                        console.log(atob(obj.Url));
                    window.open(atob(obj.Url), "_blank");
                    this.close();
                } else {
                    this.dialogs.alert("jres:33000390", "jres:33000848".format(data.oauth_service_txt, data.ixs_oap_txt)) //RC 33000848 : Souhlas pro <b>{0}</b> na OAuth profilu <b>{1}</b> byl ji� pravd�podobn� z�sk�n.
                }
            })
        }

        private testLoginOAuth(data: any) {
            this.srv().call("TestOAuth", { ixs_oap: data.ixs_oap, sluzba: data.oauth_service }).done((output: Gordic.Gin.Interface.GAdmOAuthDto) => {
                //if (this.isDebug == true)
                //    console.log(output.State)
                //$(".test-o-auth").text(output.state ? output.state : "");
            }).done((obj) => {
                if (obj.Url) {
                    if (this.isDebug == true)
                        console.log(atob(obj.Url));
                    window.open(atob(obj.Url), "_blank");
                    this.close();
                } else {
                    this.dialogs.alert("jres:33000391", "jres:33000847".format(data.oauth_service_txt, data.ixs_oap_txt)) //RC 33000847 : Slu�bu <b>{0}</b> na OAuth profilu <b>{1}</b> je pravd�podobn� mo�n� pou��vat.
                }
            })
        }

        private oAuthProfilCancel(ev, ctx) {
            var cnt = $.content($(ev.target));
            cnt.close();
        }
    }
}